<div class="swatch-outer"
  [class.b-a]="selected || isCheckbox()"
  [class.swatch--big]="isBig"
  [class.swatch--huge]="isHuge"
  [class.swatch--round]="isRound"
  [ngClass]="isCheckbox() ? 'b-col-b' : 'b-col-11'">

  @if (selected  || !isCheckbox() ) {
    <div class="overflow-hidden b-a pos-relative swatch-inner"
      [ngClass]="isCheckbox() ? 'b-col-b' : 'b-col-5'">
      @switch (getType()) {
        <!-- image -->
        @case ('image') {
          @if (option !== 'checkbox') {
            <img class="fill"
              [image]="image || option?.swatch"
              />
          }
        }
        <!-- color -->
        @case ('background') {
          <span class="fill"
          [style.background-color]="option !== 'checkbox' && option.swatch"></span>
        }
        <!-- checkbox -->
        @default {
          <span class="fill bg-col-b"
          ></span>
        }
      }
    </div>
  }
</div>